import { Injectable } from '@angular/core';
import { Alert, AlertController, NavController } from 'ionic-angular';

@Injectable()
export class GuiProvider {

	private nav: NavController;

	constructor(public alertController : AlertController) {
	}

	init(nav: NavController) {
		this.nav = nav;
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Nachricht und
	 * einem OK-Button. Nach Klick auf OK passiert nichts.
	 */
	showAlert(title: string, message: string) : void {
		this.showAlertAndDo(title, message, () => {});
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Nachricht und
	 * einem OK-Button. Nach Klick auf OK wird auf die gegebene
	 * Seite gesprungen (push).
	 */
	showAlertAndPush(title: string, message: string,
		page : any) : void
	{
		this.showAlertAndDo(title, message, () => { this.nav.push(page); });
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Nachricht und
	 * einem OK-Button. Nach Klick auf OK wird eine Seite
	 * zurückgesprungen, falls möglich.
	 */
	showAlertAndPop(title: string, message: string) : void {
		this.showAlertAndDo(title, message, () => { if (this.nav.canGoBack()) this.nav.pop(); });
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Nachricht und
	 * einem OK-Button. Nach Klick auf OK wird auf die Root-Seite
	 * zurückgesprungen.
	 */
	showAlertAndPopToRoot(title: string, message: string) : void {
		this.showAlertAndDo(title, message, () => { this.nav.popToRoot(); });
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Nachricht und
	 * einem OK-Button. Nach Klick auf OK wird der gegebene
	 * Code ausgeführt.
	 */
	showAlertAndDo(title: string, message: string, handler: () => void) : void
	{
		let alert = this._createAlert(title, message);
		this._addButton(alert, 'OK', handler);
		this._showAlert(alert);
	}

	/**
	 * Zeigt einen Alert mit der gegebenen Frage und
	 * Ja-/Nein-Button. Der entsprechende gegebene Code wird ausgeführt.
	 */
	showAlertYesOrNo(title: string, message: string,
		yesHandler: () => void, noHandler: () => void) : void
	{
		let alert = this._createAlert(title, message);
		this._addButton(alert, 'Ja', yesHandler);
		this._addButton(alert, 'Nein', noHandler);
		this._showAlert(alert);
	}

	/**
	 * Erstellt einen Alert mit der gegebenen Nachricht und gibt diesen zurück.
	 */
	private _createAlert(title: string, message: string) : Alert {
		let alert = this.alertController.create({
			title: title,
			subTitle: message
		});
		return alert;
	}

	/**
	 * F�gt dem gegebenen Alert einen Button mit der entsprechenden Aktion hinzu.
	 */
	private _addButton(alert: Alert, text: string, handler: () => void) : void {
		alert.addButton({
			text: text,
			handler: handler
		});
	}

	/**
	 * Zeigt den gegebenen Alert an.
	 */
	private _showAlert(alert: Alert) : void {
		alert.present();
	}

}



// WEBPACK FOOTER //
// ./src/providers/gui.provider.ts